import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/commerce-php/commerce-php/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const InlineAlert = makeShortcode("InlineAlert");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "magento_companyrelationsharedcatalog-module"
    }}>{`Magento_CompanyRelationSharedCatalog module`}</h1>
    <p>{`The Magento_CompanyRelationSharedCatalog module allows a merchant to assign/unassign shared catalog to parent and its child companies.`}</p>
    <h2 {...{
      "id": "installation-details"
    }}>{`Installation details`}</h2>
    <p>{`This module does not create any backward incompatible changes.`}</p>
    <h2 {...{
      "id": "structure"
    }}>{`Structure`}</h2>
    <p><a parentName="p" {...{
        "href": "https://developer.adobe.com/commerce/php/development/build/component-file-structure/"
      }}>{`Learn about a typical file structure for a Magento 2 module`}</a>{`.`}</p>
    <h2 {...{
      "id": "extensibility"
    }}>{`Extensibility`}</h2>
    <p>{`Extension developers can interact with the Magento_CompanyRelationSharedCatalog module. For more information about the Magento extension mechanism, see `}<a parentName="p" {...{
        "href": "https://developer.adobe.com/commerce/php/development/components/plugins/"
      }}>{`Magento plug-ins`}</a>{`.`}</p>
    <p><a parentName="p" {...{
        "href": "https://developer.adobe.com/commerce/php/development/components/dependency-injection/"
      }}>{`The Magento dependency injection mechanism`}</a>{` enables you to override the functionality of the Magento_CompanyRelation module.`}</p>
    <h3 {...{
      "id": "layouts"
    }}>{`Layouts`}</h3>
    <p>{`For more information about layouts, see the `}<a parentName="p" {...{
        "href": "https://developer.adobe.com/commerce/frontend-core/guide/layouts/"
      }}>{`Layout documentation`}</a>{`.`}</p>
    <h3 {...{
      "id": "ui-components"
    }}>{`UI components`}</h3>
    <p>{`For more information, see `}<a parentName="p" {...{
        "href": "https://developer.adobe.com/commerce/frontend-core/ui-components/components/listing-grid/"
      }}>{`UI Listing/Grid Component`}</a>{`.`}</p>
    <InlineAlert slots="text" mdxType="InlineAlert" />
The version of this module is 1.5.1.

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      